import { render } from "./EnbTitlePage.vue?vue&type=template&id=672eeb09&scoped=true"
import script from "./EnbTitlePage.vue?vue&type=script&lang=js"
export * from "./EnbTitlePage.vue?vue&type=script&lang=js"

import "./EnbTitlePage.vue?vue&type=style&index=0&id=672eeb09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672eeb09"]])

export default __exports__